import React from "react";
import PropTypes from "prop-types";
import AdminSubHeader from "../../layouts/partials/AdminSubheader";
import {Trans} from "react-i18next";
import Dropzone from "react-dropzone";
import {defaultSuccess} from "../../../libs/utils";
import Confirm from "../../../base/Confirm";
import {uploadRegistrations} from "../../../services/api/registrations";
import axiosInstance from "../../../services/api";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {selectEvent} from "../../../redux/preferences/selectors";

const fileDownload = require("js-file-download");

class _RegistrationsImport extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};

        this._downloadExcel = this._downloadExcel.bind(this);
        this._onDrop = this._onDrop.bind(this);
    }

    static propTypes = {
        event: PropTypes.object
    };

    _onDrop(acceptedFiles, rejectedFiles) {
        Confirm(
            "Are you sure you want to upload all data in the file you are uploading?",
            {
                title: "Upload registrations",
                confirmStyle: "btn-danger",
                confirmText: "Import"
            }
        ).then(
            result => {
                acceptedFiles.forEach(file => {
                    let data = new FormData();
                    data.append("excel", file);
                    uploadRegistrations(this.props.event.id, data)
                        .then(response => {
                            defaultSuccess("Import Successful.");
                        })
                        .catch(e => {
                            this.setState({
                                errors: e.response.data
                            });
                        });
                });
            },
            result => {
            }
        );
    }

    _downloadExcel() {
        const baseUrl = process.env.REACT_APP_API_BASE_URL;

        axiosInstance({
            method: "get",
            url: `${baseUrl}events/${this.props.event.id}/import-users/download-template`,
            responseType: "blob"
        }).then(response => {
            fileDownload(response.data, "registration-import.xlsx");
        });
    }

    render() {
        const {errors} = this.state;

        const breadcrumbs = [
            {
                title: "Registrations",
                to: "/admin/registrations"
            }
        ];

        return [
            <AdminSubHeader
                title="Registrations Import"
                key="subheader"
                breadcrumbs={breadcrumbs}
            />,
            <div className="m-content" key="content">
                <div className="row">
                    <div className="col-md-12 col-lg-6">
                        <div className="m-portlet">
                            <div className="m-portlet__head">
                                <div className="m-portlet__head-caption">
                                    <div className="m-portlet__head-title">
                                        <span className="m-portlet__head-icon">
                                            <i className="la la-file-excel-o"/>
                                        </span>
                                        <h3 className="m-portlet__head-text">
                                            <Trans>CrewMemberExcelImportTitle</Trans>
                                        </h3>
                                    </div>
                                </div>
                            </div>
                            <div className="m-portlet__body">
                                <div>
                                    <a
                                        className="btn btn-primary btn-block m--margin-bottom-10"
                                        onClick={this._downloadExcel}
                                    >
                                        <span className="la la-download"/>
                                        {" "}
                                        <Trans>RegistrationsExcelDownload</Trans>
                                    </a>
                                    <Dropzone
                                        onDrop={this._onDrop}
                                    >
                                        {({getRootProps}) => (
                                            <div
                                                {...getRootProps()}
                                                className="m-dropzone dropzone dz-clickable"
                                            >
                                                <div className="m-dropzone__msg dz-message needsclick">
                                                    <h3 className="m-dropzone__msg-title">
                                                        <Trans>registrationsUploadTitle</Trans>
                                                    </h3>
                                                    <span className="m-dropzone__msg-desc">
                                                        <Trans>registrationsUploadDescription</Trans>
                                                    </span>
                                                </div>
                                            </div>
                                        )}
                                    </Dropzone>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-9">
                        {errors && (
                            <div className="col-xl-12 ">
                                <div className="alert alert-danger">
                                    <h4>Upload Failed</h4>
                                    {errors.message && <strong>{errors.message}</strong>}
                                    <ul>
                                        {errors.errors && errors.errors.flat().map(error => (
                                            <li key={error}>{error}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        ];
    }
}

const mapDispatchToProps = dispatch => ({});

const mapStateToProps = function (state) {
    return {
        event: selectEvent(state)
    };
};

const RegistrationsImport = withRouter(
    connect(mapStateToProps, mapDispatchToProps)(_RegistrationsImport)
);

export default RegistrationsImport;
